import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import "./upsellModalStyles.css";
import InvoicePage from "../app/(general-header)/subscription/invoice/page";

const root = createRoot(document.getElementById("subscription-invoice-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <InvoicePage />
    </StoreProvider>
  </React.StrictMode>
);
